import { render } from "./ScoreBoard.vue?vue&type=template&id=c66a389c"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__